export default __webpack_public_path__ + "locales/lo-LA/DataReassignmentDialog.json?hash=12353c1f5a7f085e02bfc13925ab0829";